import React from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import {
  Modal,
  Typography,
  Select,
  Divider,
  Radio,
  Space,
  Spin,
  Button,
} from 'antd';
import { channelAdminConfig } from '../../../skills/skills_action';
import queryString from 'query-string';
import {
  InfoCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { useState, useEffect } from 'react';

const { Text } = Typography;
const { Option } = Select;
const ignoreFields = {
  summary: 1,
  status: 1,
  priority: 1,
  key: 1,
  assignee: 1,
  issuetype: 1,
  issuekey: 1,
};
const ViewCardCustomization = (props) => {
  const dispatch = useDispatch();
  const [fieldsAlignment, setFieldsAlignment] = useState('horizontal');
  const [selectedType, setSelectedType] = useState('showfields');
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [whitelistPrimaryFields, setWhitelistPrimaryFields] = useState([]);
  const [whitelistCustomFields, setWhitelistCustomFields] = useState([]);
  const [hidePrimaryFields, setHidePrimaryFields] = useState([]);
  const [hideCustomFields, setHideCustomFields] = useState([]);
  const params = queryString.parse(props.location.search);
  const channelid = params.channel_id || props.channel_id || null;
  const handleReset = () => {
    setWhitelistPrimaryFields([]);
    setWhitelistCustomFields([]);
    setHidePrimaryFields([]);
    setHideCustomFields([]);
    setFieldsAlignment('horizontal');
  };
  const showResetConfirm = () => {
    Modal.confirm({
      title: 'Are you sure you want to reset to defaults?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Confirm',
      cancelText: 'Cancel',
      onOk: () => {
        handleReset();
      },
    });
  };
  useEffect(() => {
    const channelConfig =
      props.commonChannelConfig &&
      props.commonChannelConfig.find(
        (config) => config.channel_id === channelid
      );
    if (channelConfig && channelConfig.viewCardCustomization) {
      setSelectedType(channelConfig.viewCardCustomization.selectedType);
      if (channelConfig.viewCardCustomization.whitelistFields) {
        setWhitelistPrimaryFields(
          channelConfig.viewCardCustomization.whitelistFields
            .whitelistPrimaryFields
        );
        setWhitelistCustomFields(
          channelConfig.viewCardCustomization.whitelistFields
            .whitelistCustomFields
        );
      }
      if (channelConfig.viewCardCustomization.hideFields) {
        setHidePrimaryFields(
          channelConfig.viewCardCustomization.hideFields.hidePrimaryFields
        );
        setHideCustomFields(
          channelConfig.viewCardCustomization.hideFields.hideCustomFields
        );
      }
      setFieldsAlignment(
        channelConfig.viewCardCustomization.fieldsAlignment || 'horizontal'
      );
    }
  }, []);
  const handleUpdate = async () => {
    const skill_id = props.match.params.skill_id;
    const wId = props.match.params.wId;
    const data = {
      viewCardCustomization: {
        selectedType,
        whitelistFields: {
          whitelistCustomFields,
          whitelistPrimaryFields,
        },
        hideFields: {
          hidePrimaryFields,
          hideCustomFields,
        },
        fieldsAlignment,
      },
    };

    await dispatch(
      channelAdminConfig(
        wId,
        skill_id,
        channelid,
        data,
        props.isGridSharedChannel
      )
    );
    props.close();
  };
  const handlePrimaryFields = (values) => {
    if (selectedType === 'showfields') {
      setWhitelistPrimaryFields(values);
    } else {
      setHidePrimaryFields(values);
    }
  };
  const handleCustomFields = (values) => {
    if (selectedType === 'showfields') {
      setWhitelistCustomFields(values);
    } else {
      setHideCustomFields(values);
    }
  };
  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `/bot/api/w/${props.match.params.wId}/jira/${
          props.match.params.skill_id
        }/user/${localStorage.getItem('trooprUserId')}/field`
      )
      .then((res) => {
        if (res.data.success) {
          setLoading(false);
          setFields(res.data.items || []);
        }
      });
  }, []);
  return (
    <Modal
      centered={true}
      okText='Update'
      width={800}
      title={'Issue view customization'}
      visible={props.open}
      onCancel={props.close}
      footer={[
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <Button type='secondary' key='back' onClick={showResetConfirm}>
              Reset
            </Button>
          </div>
          <div>
            <Button key='Cancel' type='secondary' onClick={props.close}>
              Cancel
            </Button>
            <Button key='submit' type='primary' onClick={handleUpdate}>
              Update
            </Button>
          </div>
        </div>,
      ]}
    >
      {loading ? (
        <div
          style={{
            minHeight: '60vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size='large' style={{ display: 'block' }} />
        </div>
      ) : (
        <div>
          <Text>
            <strong>Customize fields:</strong> Customize fields to be shown in
            issue view modal in Slack
          </Text>
          <br />
          <br />
          <Radio.Group
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <Space>
              <Radio value={'showfields'}>
                <Text type='secondary'>Show Fields</Text>
              </Radio>
              <Radio value={'hidefields'}>
                <Text type='secondary'>Hide Fields</Text>
              </Radio>
            </Space>
          </Radio.Group>
          <br />
          <br />

          <Text strong>
            {selectedType === 'showfields'
              ? 'Select the fields you want to see'
              : 'Select the fields you do not want to see'}
          </Text>
          <br />
          <br />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <Text strong>Standard fields</Text>

              <Select
                mode='multiple'
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder='Select fields'
                onChange={handlePrimaryFields}
                value={
                  selectedType === 'showfields'
                    ? whitelistPrimaryFields
                    : hidePrimaryFields
                }
                style={{
                  width: 300,
                }}
              >
                {fields
                  .filter(
                    (item) => !item.custom && !ignoreFields[item.key || item.id]
                  )
                  .map((field) => {
                    return (
                      <Option value={field.key || field.id}>
                        {field.name}
                      </Option>
                    );
                  })}
              </Select>
            </div>
            <div>
              <Text strong>Custom fields</Text>
              <Select
                mode='multiple'
                placeholder='Select fields'
                onChange={handleCustomFields}
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                value={
                  selectedType === 'showfields'
                    ? whitelistCustomFields
                    : hideCustomFields
                }
                style={{
                  width: 300,
                }}
              >
                {fields
                  .filter((item) => item.custom)
                  .map((field) => {
                    return (
                      <Option value={field.key || field.id}>
                        {field.name}
                      </Option>
                    );
                  })}
              </Select>
            </div>
          </div>
          <Divider />
          <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
            <Text style={{ fontWeight: 'bold' }}>Alignment of fields :</Text>
            <Select
              onChange={(value) => setFieldsAlignment(value)}
              value={fieldsAlignment}
              style={{ width: 400 }}
              options={[
                {
                  value: 'horizontal',
                  label: 'Horizontal',
                },
                {
                  value: 'vertical',
                  label: 'Vertical',
                },
              ]}
            />
          </div>
          <br />
          <Divider style={{ padding: 0 }} />
          <div style={{ paddingBottom: '12px' }}>
            <Text type='secondary'>Note:</Text>
          </div>
          <Text style={{ paddingBottom: '8px' }} type='secondary'>
            <InfoCircleOutlined /> Issue key, Summary,issue type, priority,
            status, assignee will show on top when available.
          </Text>
        </div>
      )}
    </Modal>
  );
};

export default withRouter(ViewCardCustomization);
